export default __webpack_public_path__ + "static/13-service-workies-40b266da6c8f9d88d43aed499b180364.png";